// TODO: This is the flow template every component should use -
// we should refactor any that are not using it, or remove old components

export const flows = {
    flow_a: {
        version: "flow_a",
        pages: [
            "GlutenSensitivity1",
            "WhatPlacesDoYouWant1",
            "LocationPreference",
            "OccasionTypes",
            "CommunityMap",
            'EmailScreen1',
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSlider"
        }
    },
    flow_b: {
        version: "flow_b",
        pages: [
            "GlutenSensitivity1",
            "AtlyIntro1",
            "DietaryRestrictions",
            'TagsStatement',
            "SearchTarget",
            "FeaturePreference",
            "SafetyRankingExplanation",
            "SafetyRankingStatement",
            "InformationSources",
            "ReviewAggregationStatement",
            "WhatPlacesDoYouWant1",
            "InformationAccuracyQuestion",
            "InformationUpdateStatement",
            "CommunityMap",
            'EmailScreen1',
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSlider"
        }
    },
    flow_c: {
        version: "flow_c",
        pages: [
            "GlutenSensitivity1",
            "AtlyIntro1",
            'EmailScreen2',
            "DietaryRestrictions",
            'TagsStatement',
            "SearchTarget",
            "FeaturePreference",
            "SafetyRankingExplanation",
            "SafetyRankingStatement",
            "InformationSources",
            "ReviewAggregationStatement",
            "WhatPlacesDoYouWant1",
            "InformationAccuracyQuestion",
            "InformationUpdateStatement",
            "CommunityMap",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSlider"
        }
    },
    flow_d: {
        version: "flow_d",
        pages: [
            "GlutenSensitivity1",
            "AtlyIntro1",
            'EmailScreen2',
            "DietaryRestrictions",
            'TagsStatement',
            "SearchTarget",
            "FeaturePreference",
            "SafetyRankingExplanation",
            "SafetyRankingStatement",
            "InformationSources",
            "ReviewAggregationStatement",
            "WhatPlacesDoYouWant1",
            "InformationAccuracyQuestion",
            "InformationUpdateStatement",
            "CommunityMap",
            "PreCheckout",
        ],
        components: {
            drawerButton: "SimpleDrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderCosmic"
        }
    },
    flow_e: {
        version: "flow_e",
        pages: [
            "GlutenSensitivity1",
            "WhatPlacesDoYouWant1",
            "Statement1",
            "GlutenSensitivity2",
            "DietaryRestrictions",
            "DiningPreference",
            "PriceRange",
            "WhatPlacesDoYouWant1",
        ],
    },
    flow_f: {
        version: "flow_f",
        pages: [
            "GlutenSensitivity1",
            "SearchTarget",
            "DiningChallenges",
            "SafetyRankingStatement",
            "CommunityValidationStatement",
            "GlobalCoverageStatement",
            "AggregatedInfoStatement",
            "DietitianStatement",
            "RealtimeUpdatesStatement",
            "CrossContaminationStatement",
            "TravelFeaturesStatement",
            "CommunityMap",
            'EmailScreen1',
            "PreCheckout",
        ],
    },
    flow2_e: {
        version: "flow2_e",
        pages: [
            'EmailScreen2',
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly"
        }
    },
    flow2_e_test: {
        version: "flow2_e_test",
        pages: [
            'EmailScreen2',
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly"
        }
    },
    flow2_e2: {
        version: "flow2_e2",
        pages: [
            'EmailScreen2',
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtlyNoClose"
        }
    },
    flow2_emailAtEnd: {
        version: "flow2_emailAtEnd",
        pages: [
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            'EmailScreen3',
            "Loading1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel2",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly2"
        }
    },
    flow2_f: {
        version: "flow2_f",
        pages: [
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            'EmailScreen3',
            "Loading1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel2",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly"
        }
    },
    flow_testimonial: {
        version: "flow_testimonial",
        pages: [
            'EmailScreen2',
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonial",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_a: {
        version: "flow_testimonial",
        pages: [
            "EmailScreen2",
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PreCheckoutImproved",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_b: {
        version: "flow_testimonial",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PreCheckoutImproved",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_c: {
        version: "flow_testimonial",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    web2app_testimonial_flow: {
        version: "web2app_testimonial_flow",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "InAppQuizResultsScreen",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_april: {
        version: "testimonial_april",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PaymentPageRedirect",
            // "AprilPricingPage",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    back_to_school: {
        version: "BackToSchool",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    back_to_school_test: {
        version: "BackToSchool",
        pages: [
            "SafetyOfPlaces1",
            "LoadingImproved",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    tt_back_to_school: {
        version: "tt_back_to_school",
        pages: [
            'EmailScreen2',
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonUriel",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly"
        }
    },
    tt_back_to_school_test: {
        version: "tt_back_to_school_test",
        pages: [
            "Loading1",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
    },
    testimonial_april_gfe1b: {
        version: "testimonial_april_gfe1b",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_april_gfe1b_test: {
        version: "testimonial_april_gfe1b_test",
        pages: [
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    web2app_aprilpasta: {
        version: "web2app_aprilpasta",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "InAppQuizResultsScreen",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    aprilburger: {
        version: "aprilburger",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1", "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PaymentPageRedirect",
            // "AprilPricingPage"
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    aprilburger_test: {
        version: "aprilburger_test",
        pages: [
            "PerfectFit1",
            // "AprilPricingPage",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_april_test: {
        version: "testimonial_april_test",
        pages: [
            "PerfectFit1",
            // "AprilPricingPage",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    tt_april_testimonial: {
        version: "tt_april_testimonial",
        pages: [
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonUriel",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly"
        }
    },
};
